import { create } from 'zustand';
import { INetExposure } from '../../sp-types/netExposureType';
export const GENERAL_ID = 'general';
interface IExposureStoreData {
  currentSelectedMaterialId: string;
  setCurrentSelectedMaterialId: (_newId: string) => void;
  netExposure: INetExposure;
  setNetExposure: (_newNetExposure: INetExposure) => void;
  isNetExposureLoading: boolean;
  setIsNetExposureLoading: (_loading: boolean) => void;
}

export const useExposureStore = create<IExposureStoreData>((set) => ({
  currentSelectedMaterialId: GENERAL_ID,
  setCurrentSelectedMaterialId: (newMaterialId) => set({ currentSelectedMaterialId: newMaterialId }),
  netExposure: { materialsExposure: {}, updatedAt: new Date() },
  setNetExposure: (newNetExposure) => set({ netExposure: newNetExposure, isNetExposureLoading: false }),
  isNetExposureLoading: true,
  setIsNetExposureLoading: (status: boolean) => set({ isNetExposureLoading: status }),
}));
